<template>
  <admin-layout title="Testes" menu="Testes">
    <div class="row mt-3">
      <div class="col-lg-2 col-xs-12"></div>
      <div class="col-lg-8">
        <h4 class="block_header">TESTES DISPONÍVEIS</h4>
        <div class="card mt-3">
          <div class="card-body formJov">
            <p>
              <strong>
                <inertia-link href="/recruiters/assessments/bigfives">
                  <span class="mr-3"> BIGFIVE </span>
                  <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
                </inertia-link>
              </strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  </admin-layout>
</template>

<script>
export default {};
</script>

<style>
</style>